import React from 'react';

const Map = () => {
	return(
		<iframe className="map" title="mapa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13124.817583740692!2d-77.09855502675602!3d-12.041344580520578!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105ceab48949897%3A0x869ee5e30cef983!2sJr.%20Piura%20129%2C%20Carmen%20de%20La%20Legua%20-%20Reynoso%2007006!5e0!3m2!1ses-419!2spe!4v1628279513845!5m2!1ses-419!2spe" width="100%" height="450" style={{border:0}} allowfullscreen="" loading="lazy"></iframe>
	)
}
export default Map;